import * as React from "react";
import { cn } from "../../../lib/cn";

const Link = React.forwardRef(
  /**
   * @param {React.HTMLProps<React.ReactHTMLElement<"a">> & { as?: React.ElementType | import("styled-components").CSSObject, external?: boolean, href external?: boolean }} props
   * @returns {JSX.Element}
   */
  ({ as: Component = "a", className, external, href, children, ...props }, ref) => {
    const externalProps = external
      ? {
        target: "_blank",
        rel: "noopener noreferrer",
      }
      : {};

    return (
      <Component
        ref={ref}
        href={href}
        className={cn(
          // Base styles
          "inline-flex items-center gap-1",
          "text-app-primary-cta-high-contrast hover:brightness-[1.50] active:brightness-[1.50] active:scale-[0.98]",
          "transition-all duration-200 ease-in-out",
          "outline-none focus-visible:ring-2 focus-visible:ring-app-primary-cta focus-visible:ring-offset-2",
          "cursor-pointer",
          "disabled:opacity-50 disabled:cursor-not-allowed",
          // Custom classes
          className
        )}
        {...externalProps}
        {...props}
      >
        {children}
      </Component>
    );
  }
);

Link.displayName = "Link";

export { Link };
